var fowtr_module_chapter_1 = (function (fowtr_module_chapter_1) {

    fowtr_module_chapter_1.init = function(chapter){

      if(fowtr_module_chapter_1.controller){
        // console.log('destroying fowtr_module_chapter_1.controller');
        fowtr_module_chapter_1.controller.destroy(true);
        fowtr_module_chapter_1.controller = null;
      }
      // gsap.killTweensOf("*");
      gsap.globalTimeline.clear();



      if(!fowtr_module_utilities.disableFancyStuff) {
        $("#fowtr-chapter1 #fowtr-article1 .fowtr-parallax-bg video").prop('muted', true);
        $("#fowtr-chapter1 #fowtr-article1 .fowtr-parallax-bg video").get(0).play();
      }



      // Video
      var mainVideo = $('#fowtr-chapter1 #fowtr-article1 video');
      // var baseSrc = 'https://dhl-future-of-work-trend-report.fra1.cdn.digitaloceanspaces.com/video/';
      mainVideo.removeAttr('src');
      var baseSrc = mainVideo.attr('data-base-ref') + 'FoW-Loop-video_v2_';
      if($(window).width() > 1000) {
        // mainVideo.append("<source type='video/mp4' src='"+baseSrc+"3840x2160.mp4' />");
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1920x1080.mp4' />");
      } else if($(window).width() > 700) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1920x1080.mp4' />");
      } else if($(window).width() > 400) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1280x720.mp4' />");
      } else if($(window).width() > 300) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"852x480.mp4' />");
      } else {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"352x240.mp4' />");
      }




      // console.log('fowtr_module_chapter_1 initialised');

      // PARALLAX CONTROLLER
      // duration is 300% - meaning, if will 'do stuff' for 300% of the height - and as they are 100% height, that covers them 'coming in', 'in', and 'going out' of viewport

      fowtr_module_chapter_1.controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          // triggerHook: "onEnter",
          // duration: "300%"
        }});



      if(fowtr_module_utilities.disableFancyStuff) fowtr_module_chapter_1.controller = null;


      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2", duration: "100%", triggerHook: "onEnter"})
      //         .on("start", function (e) {
      //           console.log('scrollmagic #fowtr-chapter1 #fowtr-article2 at start');
      //         })
      //         .addTo(fowtr_module_chapter_1.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 1
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter1 #fowtr-article1 .fowtr-parallax-bg').css({'top':'auto','bottom':'0','height':'110%',});
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2", duration: "100%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter1 #fowtr-article1 > .fowtr-parallax-bg", {y: "50%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_1.controller);





      // ------------------------------------------------------------------------------------------------------
      // article 3
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter1 #fowtr-article3 .fowtr-parallax-bg').css({
        'height':'120%',
        'top':'-34%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article3", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter1 #fowtr-article3 > .fowtr-parallax-bg", {y: "60%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_1.controller);


      // // content stuff
      // $('#fowtr-chapter1 #fowtr-article2 .state1').css({
      //   'opacity':0,
      //   'top':'0'
      // });
      // $('#fowtr-chapter1 #fowtr-article2 .state2').css({
      //   'opacity':0,
      // });
      // // state1 fadein
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2 .pin", duration: "100%", triggerHook:'onEnter'})
      //         .setTween("#fowtr-chapter1 #fowtr-article2 .state1", {top:'50%',opacity:1, ease: Power1.easeIn})
      //         .addTo(fowtr_module_chapter_1.controller);
      // // state1 pin
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2 .pin", triggerHook:'onLeave', duration: "100%"})
      //         .setPin("#fowtr-chapter1 #fowtr-article2 .pin")
      //         .addTo(fowtr_module_chapter_1.controller);
      // // state1 fadeout
      // var tween = TweenMax.to("#fowtr-chapter1 #fowtr-article2 .state1", 1, {opacity:0, visibility:'visible',ease: Linear.easeNone, onComplete:tweenOnComplete});
      // function tweenOnComplete(){
      //   $("#fowtr-chapter1 #fowtr-article2 .state1").css('visibility','hidden');
      // }
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2 .pin", duration: 100, offset:100, triggerHook:'onLeave'})
      //         // .setTween("#fowtr-chapter1 #fowtr-article2 .state1", {opacity:0, visibility:'hidden', ease: Linear.easeNone})
      //         .setTween(tween)
      //         .addTo(fowtr_module_chapter_1.controller);

      // // state2 fadein
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2 .pin", duration: 100, offset:250, triggerHook:'onLeave'})
      //         .setTween("#fowtr-chapter1 #fowtr-article2 .state2", {opacity:1, ease: Linear.easeNone})
      //         .addTo(fowtr_module_chapter_1.controller);
      // // state2 fadeout
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article2 .pin", duration: "50%", offset:400, triggerHook:'onLeave'})
      //         .setTween("#fowtr-chapter1 #fowtr-article2 .state2", {y:-300, opacity:0, ease: Power2.easeIn})
      //         .addTo(fowtr_module_chapter_1.controller);




      

      // ------------------------------------------------------------------------------------------------------
      // article 5
      // ------------------------------------------------------------------------------------------------------
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article5", duration: "300%", triggerHook: "onEnter"})
      //         .setTween("#fowtr-chapter1 #fowtr-article5 > .fowtr-parallax-bg", {y: "149%", ease: Linear.easeNone})
      //         .addTo(fowtr_module_chapter_1.controller);


      // $('#fowtr-chapter1 #fowtr-article5 .container').css({
      //   'transform':'scale(0.9)',
      //   'opacity':0,
      // });
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article5", duration: "400px", offset:300, triggerHook: "onEnter"})
      //         .setTween("#fowtr-chapter1 #fowtr-article5 .container", {opacity: 1, scale:1, ease: Power1.easeOut})
      //         .addTo(fowtr_module_chapter_1.controller);





      // ------------------------------------------------------------------------------------------------------
      // 3 forces - article 6
      // ------------------------------------------------------------------------------------------------------


      // // pinning the section
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article6", triggerHook:'onLeave'})
      //         .setPin("#fowtr-chapter1 #fowtr-article6")
      //         .addTo(fowtr_module_chapter_1.controller);

      // // animating the cards, first one enlarging
      // var tl = new TimelineMax();

      // tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').removeClass("pinned"); }, null, null, 0);
      // tl.set("#fowtr-chapter1 #fowtr-article6 .card1, #fowtr-chapter1 #fowtr-article6 .card2, #fowtr-chapter1 #fowtr-article6 .card3", {width:'33.3%'}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 .card2, #fowtr-chapter1 #fowtr-article6 .card3", 1, {opacity:0, display:'none', ease: Linear.easeNone}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 .card1", 1, {width:'100%', ease: Power2.easeInOut}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 .card2, #fowtr-chapter1 #fowtr-article6 .card3", 1, {width:'0%', ease: Power2.easeInOut}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 .card2 h4, #fowtr-chapter1 #fowtr-article6 .card3 h4, #fowtr-chapter1 #fowtr-article6 .card2 img, #fowtr-chapter1 #fowtr-article6 .card3 img", 0.5, {opacity:0, ease: Linear.easeNone}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 h4", 1, {marginBottom:10, marginTop:110, ease: Linear.easeNone}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 img", 1, {marginBottom:10, ease: Linear.easeNone}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 .card1 .fowtr-black-overlay", 1, {opacity:0.8, ease: Linear.easeNone}, 0);
      // tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').addClass("pinned"); }, null, null, 2);
      // tl.to("#fowtr-chapter1 #fowtr-article6 img", 0.5, {opacity:0, ease: Linear.easeNone}, 0);
      // tl.to("#fowtr-chapter1 #fowtr-article6 img", 0.5, {height:0, display:'none', ease: Linear.easeNone}, 0.5);

      // // amends - don't work for mobile.
      // // tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').removeClass("pinned"); }, null, null, 0);
      // // tl.to("#fowtr-chapter1 #fowtr-article6 img", 0.5, {opacity:0, ease: Linear.easeNone}, 0);
      // // tl.to("#fowtr-chapter1 #fowtr-article6 img", 0.5, {height:0, display:'none', ease: Linear.easeNone}, 0.5);
      // // tl.to("#fowtr-chapter1 #fowtr-article6 h4", 1, {marginBottom:10, marginTop:110, ease: Linear.easeNone}, 0);
      // // tl.to("#fowtr-chapter1 #fowtr-article6 img", 1, {marginBottom:0, ease: Linear.easeNone}, 0);
      // // tl.to("#fowtr-chapter1 #fowtr-article6 .card2 .fowtr-black-overlay, #fowtr-chapter1 #fowtr-article6 .card3 .fowtr-black-overlay", 1, {opacity:0.8, ease: Linear.easeNone}, 0);
      // // tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').addClass("pinned"); }, null, null, 2);



      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article6", triggerHook:'onLeave', duration: 300})
      //   // .setClassToggle("#fowtr-chapter1 #fowtr-article6", "pinned")
      //   .setTween(tl)
      //   .addTo(fowtr_module_chapter_1.controller);



      // // animating the cards, second one enlarging


      // var tl2 = new TimelineMax();

      // tl2.to("#fowtr-chapter1 #fowtr-article6 .card1", 1, {opacity:0, width:"0%", ease: Power2.easeInOut}, 0);
      // tl2.to("#fowtr-chapter1 #fowtr-article6 .card2", 1, {opacity:1, width:"100%", ease: Power2.easeInOut}, 0);
      // tl2.to("#fowtr-chapter1 #fowtr-article6 .card2 .fowtr-black-overlay", 1, {opacity:0.8, ease: Power2.easeInOut}, 0);
      // tl2.to("#fowtr-chapter1 #fowtr-article6 .card1 h4, #fowtr-chapter1 #fowtr-article6 .card1 img", 0.5, {opacity:0, ease: Power2.easeInOut}, 0);
      // tl2.to("#fowtr-chapter1 #fowtr-article6 .card2 h4, #fowtr-chapter1 #fowtr-article6 .card2 img", 0.5, {opacity:1, ease: Power2.easeInOut, delay:0.5}, 0);

      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article12", duration: 300})
      //   .setTween(tl2)
      //   .addTo(fowtr_module_chapter_1.controller);



      // // animating the cards, third one enlarging

      // var tl3 = new TimelineMax();

      // tl3.to("#fowtr-chapter1 #fowtr-article6 .card1", 1, {opacity:0, width:"0%", ease: Power2.easeInOut}, 0);
      // tl3.to("#fowtr-chapter1 #fowtr-article6 .card2", 1, {opacity:0, width:"0%", ease: Power2.easeInOut}, 0);
      // tl3.to("#fowtr-chapter1 #fowtr-article6 .card3", 1, {opacity:1, width:"100%", ease: Power2.easeInOut}, 0);
      // tl3.to("#fowtr-chapter1 #fowtr-article6 .card3 .fowtr-black-overlay", 1, {opacity:0.8, ease: Power2.easeInOut}, 0);
      // tl3.to("#fowtr-chapter1 #fowtr-article6 .card2 h4, #fowtr-chapter1 #fowtr-article6 .card2 img", 0.5, {opacity:0, ease: Power2.easeInOut}, 0);
      // tl3.to("#fowtr-chapter1 #fowtr-article6 .card3 h4, #fowtr-chapter1 #fowtr-article6 .card3 img", 0.5, {opacity:1, ease: Power2.easeInOut, delay:0.5}, 0);

      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article16", duration: 300})
      //   .setTween(tl3)
      //   .addTo(fowtr_module_chapter_1.controller);



      // // animating the cards, ending, fadeout

      // var tl4 = new TimelineMax();

      // tl4.to("#fowtr-chapter1 #fowtr-article6", 1, {autoAlpha:0, display:'none', ease: Power2.easeInOut}, 0);

      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article22", duration: 300})
      //   .setTween(tl4)
      //   .addTo(fowtr_module_chapter_1.controller);




      // amended version 3 across


      // pinning the section
      var article6scene1 = new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article6", triggerHook:'onLeave'})
              .setPin("#fowtr-chapter1 #fowtr-article6")
              .on('update', function () {
                // ugly hack to detect if its full header, minimal header, fullscreen etc.
                if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
                  article6scene1.offset(0);
                } else {
                  if($(window).width()<768){
                    article6scene1.offset(-56);
                  } else {
                    article6scene1.offset(-108);
                  }
                }
              })
              .addTo(fowtr_module_chapter_1.controller);

      // animating the cards, first one enlarging
      var tl = new TimelineMax();

      // var pinnedMarginTop = 120; // without secondary nav
      var pinnedMarginTop = 60; // without secondary nav
      // var pinnedMarginTop = 170; // without secondary nav
      
      article6scene1.offset(-108);

      // tl.call(function() { if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) article6scene1.offset(0); }, null, null, 0.1);


      tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').removeClass("pinned"); }, null, null, 0);
      tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').removeClass("pinned"); }, null, null, 0);
      tl.to("#fowtr-chapter1 #fowtr-article6 img", 0.5, {opacity:0, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter1 #fowtr-article6 img", 0.5, {height:0, display:'none', ease: Linear.easeNone}, 0.5);
      tl.to("#fowtr-chapter1 #fowtr-article6 h4", 1, {marginBottom:15, marginTop:pinnedMarginTop, padding:0, ease: Linear.easeNone}, 0);
      tl.fromTo("#fowtr-chapter1 #fowtr-article6 .card1 .indicator", 1, {borderBottomWidth:"0px"},{borderBottomWidth:"10px", ease: Linear.easeNone}, 0);
      // tl.fromTo("#fowtr-chapter1 #fowtr-article6 h4", 1, {fontSize:"150%"},{fontSize:"120%", ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter1 #fowtr-article6 .card1 h4, #fowtr-chapter1 #fowtr-article6 a.card1", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter1 #fowtr-article6 img", 1, {marginBottom:0, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter1 #fowtr-article6 .card1 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter1 #fowtr-article6 .card2 .fowtr-black-overlay, #fowtr-chapter1 #fowtr-article6 .card3 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl.call(function() { $('#fowtr-chapter1 #fowtr-article6').addClass("pinned"); }, null, null, 2);

      // tl.call(function() { console.log('pinning article 6'); }, null, null, 0);


      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article6", triggerHook:'onLeave', duration: 300})
        // .setClassToggle("#fowtr-chapter1 #fowtr-article6", "pinned")
        .setTween(tl)
        .addTo(fowtr_module_chapter_1.controller);



      // animating the cards, second one enlarging


      var tl2 = new TimelineMax();

      tl2.to("#fowtr-chapter1 #fowtr-article6 .card1 h4, #fowtr-chapter1 #fowtr-article6 .card3 h4, #fowtr-chapter1 #fowtr-article6 a.card1, #fowtr-chapter1 #fowtr-article6 a.card3", 1, {color:'#ffffff', ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter1 #fowtr-article6 .card2 h4, #fowtr-chapter1 #fowtr-article6 a.card2", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter1 #fowtr-article6 .card1 .indicator, #fowtr-chapter1 #fowtr-article6 .card3 .indicator", 1, {borderBottomWidth:"0px", ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter1 #fowtr-article6 .card2 .indicator", 1, {borderBottomWidth:"10px", ease: Linear.easeNone}, 0);

      tl2.to("#fowtr-chapter1 #fowtr-article6 .card1 .fowtr-black-overlay, #fowtr-chapter1 #fowtr-article6 .card3 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter1 #fowtr-article6 .card2 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);


      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article12", duration: 300})
        .setTween(tl2)
        .addTo(fowtr_module_chapter_1.controller);



      // animating the cards, third one enlarging

      var tl3 = new TimelineMax();

      tl3.to("#fowtr-chapter1 #fowtr-article6 .card1 h4, #fowtr-chapter1 #fowtr-article6 .card2 h4, #fowtr-chapter1 #fowtr-article6 a.card1, #fowtr-chapter1 #fowtr-article6 a.card2", 1, {color:'#ffffff', ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter1 #fowtr-article6 .card3 h4, #fowtr-chapter1 #fowtr-article6 a.card3", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter1 #fowtr-article6 .card1 .indicator, #fowtr-chapter1 #fowtr-article6 .card2 .indicator", 1, {borderBottomWidth:"0px", ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter1 #fowtr-article6 .card3 .indicator", 1, {borderBottomWidth:"10px", ease: Linear.easeNone}, 0);

      tl3.to("#fowtr-chapter1 #fowtr-article6 .card1 .fowtr-black-overlay, #fowtr-chapter1 #fowtr-article6 .card2 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter1 #fowtr-article6 .card3 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article15", duration: 300})
        .setTween(tl3)
        .addTo(fowtr_module_chapter_1.controller);



      // animating the cards, ending, fadeout

      var tl4 = new TimelineMax();

      tl4.to("#fowtr-chapter1 #fowtr-article6", 1, {autoAlpha:0, display:'none', ease: Power2.easeInOut}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article20", duration: 300})
        .setTween(tl4)
        .addTo(fowtr_module_chapter_1.controller);


























      // ------------------------------------------------------------------------------------------------------
      // TIMELINE article 8
      // ------------------------------------------------------------------------------------------------------

      var timelineTriggerOffset = -300;
      var timelineTriggerHook = 'onCenter';
      // separators
      $.each($("#fowtr-chapter1 #fowtr-article8 .timeline-separator"), function(index, val) {
        new ScrollMagic.Scene({triggerElement: $(this)[0], triggerHook: timelineTriggerHook, offset: timelineTriggerOffset, duration:$(this).height()})
          .setTween($(this).find('div'), {height:"100%", ease: Linear.easeNone})
          .addTo(fowtr_module_chapter_1.controller);
      });

      // icons
      $.each($("#fowtr-chapter1 #fowtr-article8 img"), function(index, val) {
        $(this).css('transform','scale(0)');
        new ScrollMagic.Scene({triggerElement: $(this)[0], triggerHook: timelineTriggerHook, offset: timelineTriggerOffset})
          .setTween($(this), 0.5, {scale:1, ease: Power2.easeOut})
          .addTo(fowtr_module_chapter_1.controller);
      });


      // grey-bg h3
      $.each($("#fowtr-chapter1 #fowtr-article8 .grey-bg h3"), function(index, val) {
        $(this).css({'opacity':0,'transform':'translateY(50px)'});
        new ScrollMagic.Scene({triggerElement: $(this)[0], triggerHook: timelineTriggerHook, offset: timelineTriggerOffset})
          .setTween($(this), 0.5, {opacity:1, y:0, ease: Power2.easeOut})
          .addTo(fowtr_module_chapter_1.controller);
      });
      // grey-bg p
      $.each($("#fowtr-chapter1 #fowtr-article8 .grey-bg p"), function(index, val) {
        $(this).css({'opacity':0,'transform':'translateY(50px)'});
        new ScrollMagic.Scene({triggerElement: $(this)[0], triggerHook: timelineTriggerHook, offset: timelineTriggerOffset})
          .setTween($(this), 0.5, {opacity:1, y:0, ease: Power2.easeOut})
          .addTo(fowtr_module_chapter_1.controller);
      });


      // dates
      $.each($("#fowtr-chapter1 #fowtr-article8 .timeline-date"), function(index, val) {
        // $(this).css({'opacity':0,'transform':'translateY(50px)'});
        $(this).css('transform','scale(0)');
        new ScrollMagic.Scene({triggerElement: $(this)[0], triggerHook: timelineTriggerHook, offset: timelineTriggerOffset})
          .setTween($(this), 0.5, {scale:1, ease: Power2.easeOut})
          .addTo(fowtr_module_chapter_1.controller);
      });

      // dates text
      $.each($("#fowtr-chapter1 #fowtr-article8 .timeline-text"), function(index, val) {
        // $(this).css({'opacity':0,'transform':'translateY(50px)'});
        $(this).css('transform','scale(0)');
        new ScrollMagic.Scene({triggerElement: $(this)[0], triggerHook: timelineTriggerHook, offset: timelineTriggerOffset})
          .setTween($(this), 0.5, {scale:1, ease: Power2.easeOut})
          .addTo(fowtr_module_chapter_1.controller);
      });




      // ------------------------------------------------------------------------------------------------------
      // article 9 parallax
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter1 #fowtr-article9 .fowtr-parallax-bg').css({
      //   // 'height':'120%',
      //   'top':'-25%',
      // });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article9", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter1 #fowtr-article9 > .fowtr-parallax-bg", {y: "60%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_1.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 10 parallax
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter1 #fowtr-article10 .fowtr-parallax-bg').css({
      //   // 'height':'120%',
      //   'top':'-25%',
      // });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article10", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter1 #fowtr-article10 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_1.controller);






      // ------------------------------------------------------------------------------------------------------
      // article 11 grid svg animations
      // ------------------------------------------------------------------------------------------------------
      // -----------------------------------------------------------------------------------------------------------------------------------------
      // PEOPLE GRAPH
      // -----------------------------------------------------------------------------------------------------------------------------------------

      var element = $("#fowtr-chapter1 #fowtr-article11 .content-panel").eq(1).find('.inlinesvg');
      var article11PeopleGraphInlinesvgclasses = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article11PeopleGraphInlinesvgclasses); //put same classes on the new content

        var tl = new TimelineMax({paused: true, repeat:-1});

        // looop through the rest and hide so bottom layer shows
        // for (var i = 0; i < 100; i++) {
        //   svg.find("#Layer_2 path").eq(i).hide();
        // }

        // loop through first 50 pairs and animate them with delay
        for (var i = 0; i < 100; i=i+2) {
          tl.fromTo([svg.find("#Layer_2 path").eq(i),svg.find("#Layer_2 path").eq(i+1)],0.5,{scale:1.5,opacity:0,x:"-=15",y:"-=15"},{scale:1,opacity:1,x:"+=15",y:"+=15",delay:0.01*i},0);
        }

        // fade out 50
        for (var i = 50; i < 100; i++) {
          tl.to(svg.find("#Layer_2 path").eq(i),2,{opacity:0},1.5);
        }
        // fade in grey
        tl.to(svg.find("#Layer_1"),2,{opacity:1},1.5);

        // fade out all
        tl.to(svg.find("#Layer_1"),1,{opacity:0},12);
        tl.to(svg.find("#Layer_2"),1,{opacity:0},12);

        // inview - trigger play when in view
        svg.one('inview', {triggerTop:'bottom', triggerBottom:'top', offsetTop:0}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });



      // -----------------------------------------------------------------------------------------------------------------------------------------
      // DIVERSITY CHART
      // -----------------------------------------------------------------------------------------------------------------------------------------

      var element = $("#fowtr-chapter1 #fowtr-article11 .content-panel").eq(2).find('.inlinesvg');
      fowtr_module_utilities.inlineSvg(element,function(svg){

        var tl = new TimelineMax({paused: true});
        tl.fromTo(svg.find('#bar_1'),2,{y:164,height:0},{y:0,height:164},0);
        tl.fromTo(svg.find('#bar_2'),2,{y:30.2,height:0},{y:0,height:30.2},0);
        // tl.fromTo(svg.find('#icon_1'),2,{y:"+=164"},{y:"-=164"},0);
        tl.fromTo(svg.find('#icon_1'),2,{y:164,height:0},{y:0,height:164},0);
        tl.fromTo(svg.find('#icon_2'),2,{y:30.2,height:0},{y:0,height:30.2},0);
        tl.fromTo(svg.find('#text_1'),1,{opacity:0},{opacity:1,delay:1},0);
        tl.fromTo(svg.find('#text_2'),1,{opacity:0},{opacity:1,delay:1},0);

        // tl.to(svg,1,{opacity:0},6);

        // hopping
        tl.to(svg.find('#icon_2'),0.5,{y:"-=40",ease:Power2.easeOut},2);
        tl.to(svg.find('#icon_2'),0.5,{y:"+=40",ease:Power2.easeIn},2+0.5);
        tl.to(svg.find('#icon_2'),0.2,{y:"-=10",ease:Power2.easeOut},2+1);
        tl.to(svg.find('#icon_2'),0.2,{y:"+=10",ease:Power2.easeIn},2+1.2);
        
        tl.to(svg.find('#icon_2'),1,{y:"+=0", onComplete: function(){ tl.seek(2);}},2+1.4);

        // tl.to(svg.find('#icon_2'),0.5,{y:"-=40",ease:Power2.easeOut},4.5);
        // tl.to(svg.find('#icon_2'),0.5,{y:"+=40",ease:Power2.easeIn},4.5+0.5);
        // tl.to(svg.find('#icon_2'),0.2,{y:"-=10",ease:Power2.easeOut},4.5+1);
        // tl.to(svg.find('#icon_2'),0.2,{y:"+=10",ease:Power2.easeIn},4.5+1.2);

        // tl.seek(2,4.5);


        // inview - trigger play when in view
        svg.one('inview', {triggerTop:'bottom', triggerBottom:'top', offsetTop:0}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });






      // -----------------------------------------------------------------------------------------------------------------------------------------
      // EMPLOYEE WELL BEING GRAPHIC
      // -----------------------------------------------------------------------------------------------------------------------------------------

      var element = $("#fowtr-chapter1 #fowtr-article11 .content-panel").eq(5).find('.inlinesvg');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.css({'max-height':'195px'});

        var tl = new TimelineMax({paused: true});
        tl.fromTo(svg.find('#head'),1,{opacity:0},{opacity:1},0);
        tl.fromTo(svg.find('#_50pc'),3,{x:-20,y:-20,scale:2,opacity:0},{x:0,y:0,scale:1,opacity:1,delay:0.1,ease:Elastic.easeOut},0);
        tl.fromTo(svg.find('#_75pc'),3,{x:-20,y:-20,scale:2,opacity:0},{x:0,y:0,scale:1,opacity:1,delay:0.2,ease:Elastic.easeOut},0);
        // tl.fromTo(svg.find('#bar_2'),2,{y:60,height:0},{y:0,height:60},0);
        // // tl.fromTo(svg.find('#icon_1'),2,{y:"+=164"},{y:"-=164"},0);
        // tl.fromTo(svg.find('#icon_1'),2,{y:164,height:0},{y:0,height:164},0);
        // tl.fromTo(svg.find('#icon_2'),2,{y:60,height:0},{y:0,height:60},0);
        // tl.fromTo(svg.find('#text_1'),1,{opacity:0},{opacity:1,delay:1},0);
        // tl.fromTo(svg.find('#text_2'),1,{opacity:0},{opacity:1,delay:1},0);


        // inview - trigger play when in view
        svg.one('inview', {triggerTop:'bottom', triggerBottom:'top', offsetTop:0}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });

        function random(min, max) {
          if (max == null) { max = min; min = 0; }
          return Math.random() * (max - min) + min;
        }
        function randomMovement(element) {
          TweenLite.to(element, random(1, 1.8), {x:random(-30, 30), y:random(30, -30), ease:Power2.easeInOut, onComplete:randomMovement, onCompleteParams:[element]});
        }

        for (var i = 1; i <= 4; i++) {
          randomMovement(svg.find('#smiley'+i));
        }

        for (var i = 1; i <= 2; i++) {
          randomMovement(svg.find('#pulse'+i));
        }

        // for (var i = 1; i <= 3; i++) {
        //   randomMovement(svg.find('#jigsaw'+i));
        // }

        for (var i = 1; i <= 3; i++) {
          randomMovement(svg.find('#plus'+i));
        }

        // for (var i = 1; i <= 3; i++) {
        //   randomMovement(svg.find('#heart'+i));
        // }


      });





      // -----------------------------------------------------------------------------------------------------------------------------------------
      // MOBILE PHONES GRAPH
      // -----------------------------------------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter1 #fowtr-article11 .content-panel").eq(6).find('.inlinesvg');
      fowtr_module_utilities.inlineSvg(element,function(svg){

        var tl = new TimelineMax({paused: true, repeat:-1, yoyo: true});


        tl.set(svg.find('#smiley1 path:nth-child(2)'),{scaleY:-1,y:"+=10"},0);


        //in
        for (var i = 1; i <= 6; i++) {
          tl.fromTo(svg.find('#phone'+i),1,{x:"+=50%",y:"+=50%",scale:0,opacity:0},{x:"-=50%",y:"-=50%",scale:1,opacity:1,ease:Elastic.easeOut},0.05*i);
        }
        for (var i = 1; i <= 6; i++) {
          tl.fromTo(svg.find('#screen'+i),1,{opacity:0},{opacity:1,delay:1,ease:Linear.easeNone},0.05*i);
        }
        for (var i = 1; i <= 6; i++) {
          tl.fromTo(svg.find('#smiley'+i),1,{x:"+=50%",y:"+=50%",scale:0,opacity:0},{x:"-=50%",y:"-=50%",scale:1,opacity:1,delay:2,ease:Elastic.easeOut},0.05*i);
        }

        // screen color
        tl.set(svg.find('#screen1'),{css:{fill:'rgb(255,204,0)'}},0);
        tl.to(svg.find('#screen1'),0.5,{css:{fill:'rgb(212,5,17)'},ease:Power2.easeInOut},2.6);

        tl.set(svg.find('#smiley1 path:first-child, #smiley1 path:nth-child(2)'),{css:{stroke:'#8c8c8c'}},0);
        tl.to(svg.find('#smiley1 path:first-child, #smiley1 path:nth-child(2)'),0.5,{css:{stroke:'#ffffff'},ease:Power2.easeInOut},2.6);

        tl.set(svg.find('#smiley1 path:nth-child(3),#smiley1 path:nth-child(4)'),{css:{fill:'#8c8c8c'}},0);
        tl.to(svg.find('#smiley1 path:nth-child(3),#smiley1 path:nth-child(4)'),0.5,{css:{fill:'#ffffff'},ease:Power2.easeInOut},2.6);

        // frown
        tl.to(svg.find('#smiley1 path:nth-child(2)'),0.5,{scaleY:1,y:"-=10",ease:Power2.easeInOut},3);

        // blinking
        tl.set(svg.find('#screen1'),{opacity:0.5},4);
        tl.set(svg.find('#screen1'),{opacity:1},4.05);

        tl.set(svg.find('#screen1'),{opacity:0.5},4.2);
        tl.set(svg.find('#screen1'),{opacity:1},4.25);

        tl.set(svg.find('#screen1'),{opacity:0.5},4.3);
        tl.set(svg.find('#screen1'),{opacity:1},4.35);

        tl.set(svg.find('#screen1'),{opacity:0.5},4.6);
        tl.set(svg.find('#screen1'),{opacity:1},4.65);

        tl.set(svg.find('#screen1'),{opacity:0.5},4.8);
        tl.set(svg.find('#screen1'),{opacity:1},4.85);

        tl.set(svg.find('#screen1'),{opacity:0.5},5);
        tl.set(svg.find('#screen1'),{opacity:1},5.05);

        tl.set(svg.find('#screen1'),{opacity:0.5},5.3);
        tl.set(svg.find('#screen1'),{opacity:1},5.35);

        tl.set(svg.find('#screen1'),{opacity:0.5},5.5);
        tl.set(svg.find('#screen1'),{opacity:1},5.55);

        tl.set(svg.find('#screen1'),{opacity:0.5},5.7);
        tl.set(svg.find('#screen1'),{opacity:1},5.75);


        tl.set(svg.find('#screen1'),{opacity:0.5},5.9);
        tl.set(svg.find('#screen1'),{opacity:1},5.95);





        // tl.set({},{},"+=4");//add time to the end of the timeline
        tl.set({},{onComplete: function(){ tl.seek(4);}},"+=2");//add time to the end of the timeline




        // inview - trigger play when in view
        svg.one('inview', {triggerTop:'bottom', triggerBottom:'top', offsetTop:0}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });







      // ------------------------------------------------------------------------------------------------------
      // article 13 parallax - OLD REMOVED
      // ------------------------------------------------------------------------------------------------------
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article13", duration: "300%", triggerHook: "onEnter"})
      //   .setTween("#fowtr-chapter1 #fowtr-article13 > .fowtr-parallax-bg", {y: "200%", opacity:0, ease: Linear.easeNone})
      //   .addTo(fowtr_module_chapter_1.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 13 parallax
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter1 #fowtr-article13 .fowtr-parallax-bg').css({
      //   // 'height':'120%',
      //   'top':'-25%',
      // });
        new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article13", duration: "200%", triggerHook: "onEnter"})
        .setTween("#fowtr-chapter1 #fowtr-article13 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
        .addTo(fowtr_module_chapter_1.controller);





      // ------------------------------------------------------------------------------------------------------
      // article 17 parallax
      // ------------------------------------------------------------------------------------------------------
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article17", duration: "300%", triggerHook: "onEnter"})
      //   .setTween("#fowtr-chapter1 #fowtr-article17 > .fowtr-parallax-bg", {y: "200%", opacity:0, ease: Linear.easeNone})
      //   .addTo(fowtr_module_chapter_1.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 16 parallax
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter1 #fowtr-article16 .fowtr-parallax-bg').css({
      //   // 'height':'120%',
      //   'top':'-25%',
      // });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article16", duration: "200%", triggerHook: "onEnter"})
        .setTween("#fowtr-chapter1 #fowtr-article16 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
        .addTo(fowtr_module_chapter_1.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 17 parallax
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter1 #fowtr-article17 .fowtr-parallax-bg').css({
      //   // 'height':'120%',
      //   'top':'-25%',
      // });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article17", duration: "200%", triggerHook: "onEnter"})
        .setTween("#fowtr-chapter1 #fowtr-article17 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
        .addTo(fowtr_module_chapter_1.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 18 parallax
      // ------------------------------------------------------------------------------------------------------
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article18", duration: "200%", triggerHook: "onEnter"})
        .setTween("#fowtr-chapter1 #fowtr-article18 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
        .addTo(fowtr_module_chapter_1.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 19 parallax
      // ------------------------------------------------------------------------------------------------------
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter1 #fowtr-article19", duration: "200%", triggerHook: "onEnter"})
        .setTween("#fowtr-chapter1 #fowtr-article19 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
        .addTo(fowtr_module_chapter_1.controller);




      // ------------------------------------------------------------------------------------------------------
      // article 18 retail-e-commerce-sales-growth chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter1 #fowtr-article16 .inlinesvg");
      fowtr_module_utilities.inlineSvg(element,function(svg){

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#x_axis'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

        stagger = 0.1;
        delay = 0.5;
        speed = 1;
        tl.fromTo(svg.find('#bar_1'),speed,{css:{height:0,y:191.75}},{css:{height:191.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.fromTo(svg.find('#bar_2'),speed,{css:{height:0,y:257.75}},{css:{height:257.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*1},0);
        tl.fromTo(svg.find('#bar_3'),speed,{css:{height:0,y:221.75}},{css:{height:221.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*2},0);
        tl.fromTo(svg.find('#bar_4'),speed,{css:{height:0,y:207.75}},{css:{height:207.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*3},0);
        tl.fromTo(svg.find('#bar_5'),speed,{css:{height:0,y:185.75}},{css:{height:185.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*4},0);
        tl.fromTo(svg.find('#bar_6'),speed,{css:{height:0,y:183.75}},{css:{height:183.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*5},0);
        tl.fromTo(svg.find('#bar_7'),speed,{css:{height:0,y:137.75}},{css:{height:137.75,y:0},ease:Power4.easeInOut,delay:delay+stagger*6},0);
        
        delay = 1;
        speed = 1;
        tl.fromTo(svg.find('#label_1'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*0},0);
        tl.fromTo(svg.find('#label_2'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*1},0);
        tl.fromTo(svg.find('#label_3'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*2},0);
        tl.fromTo(svg.find('#label_4'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*3},0);
        tl.fromTo(svg.find('#label_5'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*4},0);
        tl.fromTo(svg.find('#label_6'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*5},0);
        tl.fromTo(svg.find('#label_7'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*6},0);

        tl.fromTo(svg.find('#icon_1'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*0},0);
        tl.fromTo(svg.find('#icon_2'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*1},0);
        tl.fromTo(svg.find('#icon_3'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*2},0);
        tl.fromTo(svg.find('#icon_4'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*3},0);
        tl.fromTo(svg.find('#icon_5'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*4},0);
        tl.fromTo(svg.find('#icon_6'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*5},0);
        tl.fromTo(svg.find('#icon_7'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*6},0);


        var options = {
          intentPollInterval:20,
          followMouse:true,
          fadeInTime:0,
          fadeOutTime:0,
          // openEvents:['mouseover','focus']
          // closeDelay:0
        }
        if(fowtr_module_utilities.isMobile) options = {};

        svg.find('#bargroup_1').data('powertip', 'World: 27.6% Growth').powerTip(options);
        svg.find('#bargroup_2').data('powertip', 'Latin America: 36.7% Growth').powerTip(options);
        svg.find('#bargroup_3').data('powertip', 'North America: 31.8% Growth').powerTip(options);
        svg.find('#bargroup_4').data('powertip', 'Central & Eastern Europe: 29.1% Growth').powerTip(options);
        svg.find('#bargroup_5').data('powertip', 'Asia-Pacific: 26.4% Growth').powerTip(options);
        svg.find('#bargroup_6').data('powertip', 'Western Europe: 26.3% Growth').powerTip(options);
        svg.find('#bargroup_7').data('powertip', 'Middle East & Africa: 19.8% Growth').powerTip(options);






        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });











      // ------------------------------------------------------------------------------------------------------
      // article 20 driver-shortfall chart
      // ------------------------------------------------------------------------------------------------------

      var element = $("#fowtr-chapter1 #fowtr-article18 .inlinesvg");
      fowtr_module_utilities.inlineSvg(element,function(svg){

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#x_axis'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0.3},0);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

        stagger = 0.1;
        delay = 0.5;
        speed = 1;
        tl.fromTo(svg.find('#bar_1'),speed,{css:{height:0,y:70.92}},{css:{height:70.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.fromTo(svg.find('#bar_2'),speed,{css:{height:0,y:241.92}},{css:{height:241.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*1},0);
        tl.fromTo(svg.find('#bar_3'),speed,{css:{height:0,y:102.92}},{css:{height:102.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*2},0);
        tl.fromTo(svg.find('#bar_4'),speed,{css:{height:0,y:255.92}},{css:{height:255.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*3},0);
        tl.fromTo(svg.find('#bar_5'),speed,{css:{height:0,y:241.92}},{css:{height:241.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*4},0);
        tl.fromTo(svg.find('#bar_6'),speed,{css:{height:0,y:340.92}},{css:{height:340.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*5},0);
        tl.fromTo(svg.find('#bar_7'),speed,{css:{height:0,y:102.92}},{css:{height:102.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*6},0);
        tl.fromTo(svg.find('#bar_8'),speed,{css:{height:0,y:282.92}},{css:{height:282.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*6},0);
        
        delay = 1;
        speed = 1;
        tl.fromTo(svg.find('#label_1'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*0},0);
        tl.fromTo(svg.find('#label_2'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*1},0);
        tl.fromTo(svg.find('#label_3'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*2},0);
        tl.fromTo(svg.find('#label_4'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*3},0);
        tl.fromTo(svg.find('#label_5'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*4},0);
        tl.fromTo(svg.find('#label_6'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*5},0);
        tl.fromTo(svg.find('#label_7'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*6},0);
        tl.fromTo(svg.find('#label_8'),speed,{css:{scale:0,autoAlpha:0,transformOrigin:'center'}},{css:{scale:1,autoAlpha:1},ease:Bounce.easeOut,delay:delay+stagger*7},0);



        var options = {
          intentPollInterval:20,
          followMouse:true,
          fadeInTime:0,
          fadeOutTime:0,
          // openEvents:['mouseover','focus']
          // closeDelay:0
        }
        if(fowtr_module_utilities.isMobile) options = {};
        
        svg.find('#bar_1').data('powertip', 'EU: 5% shortfall in 2020').powerTip(options);
        svg.find('#bar_2').data('powertip', 'EU: 17% shortfall in 2021').powerTip(options);
        svg.find('#bar_3').data('powertip', 'Mexico: 7% shortfall in 2020').powerTip(options);
        svg.find('#bar_4').data('powertip', 'Mexico: 18% shortfall in 2021').powerTip(options);
        svg.find('#bar_5').data('powertip', 'Russia: 17% shortfall in 2020').powerTip(options);
        svg.find('#bar_6').data('powertip', 'Russia: 24% shortfall in 2021').powerTip(options);
        svg.find('#bar_7').data('powertip', 'Turkey: 7% shortfall in 2020').powerTip(options);
        svg.find('#bar_8').data('powertip', 'Turkey: 10% shortfall in 2021').powerTip(options);







        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });






      // ------------------------------------------------------------------------------------------------------
      // article 22 click icon
      // ------------------------------------------------------------------------------------------------------
      // var element = $("#fowtr-chapter1 #fowtr-article20 .click_icon");
      // fowtr_module_utilities.inlineSvg(element,function(svg){

      // // var element = $('#fowtr-chapter1 #fowtr-article22 .click_icon');
      // // fowtr_module_utilities.loadSVGasXML(element.attr('src'),function(responseText){
      // //   var svg = $(responseText);
      //   svg.attr('class',element.attr('class')); //put same classes on the new content
      //   // element.replaceWith(svg);

      //   var tl = new TimelineMax({repeat:-1});
      //   tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);

      // });





    };



    fowtr_module_chapter_1.destroy = function(chapter){
      
      console.log('destroy chapter '+chapter);


    };//end destroy function





    return fowtr_module_chapter_1;
}(fowtr_module_chapter_1 || {}));

